export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const casinoGames = {
  all: {
    aviatorSprb: {
      redirectUrl: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/Aviator.webp",
      alt: "",
      name: "Aviator",
      providerName: "Spribe",
    },
    AndarBaharEzg: {
      redirectUrl: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/AndarBahar.webp",
      alt: "",
      name: "Andar Bahar",
      providerName: "Ezugi",
    },
    AutoRouletteEzg: {
      redirectUrl: "/casino/ezg-auto-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/AutoRoulette.webp",
      alt: "",
      name: "Auto Roulette",
      providerName: "Ezugi",
    },
    SpeedRouletteEzg: {
      redirectUrl: "/casino/ezg-speed-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SpeedRoulette.webp",
      alt: "",
      name: "Speed Roulette",
      providerName: "Ezugi",
    },
    LightningRouletteEvo: {
      redirectUrl: "/casino/ezgevo-lightning-roulette",
      code: "1000092",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/LightningRoulette.webp",
      alt: "",
      name: "Lightning Roulette",
      providerName: "Evolution",
    },
    DragonTigerEvo: {
      redirectUrl: "/casino/ezgevo-dragon-tiger-evo",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger/evolution/DragonTiger.webp",
      alt: "",
      name: "Dragon Tiger",
      providerName: "Evolution",
    },
    BaccaratEzg: {
      redirectUrl: "/casino/ezg-baccarat",
      code: "101",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/Baccarat.webp",
      alt: "",
      name: "Baccarat",
      providerName: "Ezugi",
    },
    CrazyTimeEvo: {
      redirectUrl: "/casino/ezgevo-crazy-time",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/CrazyTime.jpg",
      alt: "",
      name: "Crazy Time",
      providerName: "Evolution",
    },
    OnedayteenpattiEzg: {
      redirectUrl: "/casino/ezg-one-day-teen-patti",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/poker/Onedayteenpatti.jpg",
      alt: "",
      name: "One Day Teen Patti",
      providerName: "Ezugi",
    },
    name: "All",
    key: "all",
  },

  andarbahar: {
    AndarBaharEzg: {
      redirectUrl: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/AndarBahar.webp",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      providerName: "Ezugi",
    },
    OTTAndarBaharEzg: {
      redirectUrl: "/casino/ezg-casino-marina-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/OTTAndarBahar.webp",
      alt: "OTT Andar Bahar",
      name: "OTT Andar Bahar",
      providerName: "Ezugi",
    },
    UltimateAndarBaharEzg: {
      redirectUrl: "/casino/ezg-ultimate-andar-bahar",
      code: "328000",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/UltimateAndarBahar.webp",
      alt: "Ultimate Andar Bahar",
      name: "Ultimate Andar Bahar",
      providerName: "Ezugi",
    },

    AndarBaharAura: {
      redirectUrl: "/casino/aura-andar-bahar",
      code: "",
      casino: "aura",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/aura/AndarBahar.webp",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      providerName: "Aura",
    },
    AndarBaharVirtualAura: {
      redirectUrl: "/casino/aura-andar-bahar-virtual",
      code: "",
      casino: "aura",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/aura/AndarBaharVirtual.webp",
      alt: "Andar Bahar (Virtual)",
      name: "Andar Bahar (Virtual)",
      providerName: "Aura",
    },

    AndarBaharVivo: {
      redirectUrl: "/casino/vivo-andar-bahar",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/Vivo/AndarBahar.webp",
      alt: "andar bahar",
      name: "Andar Bahar",
      providerName: "Vivo",
    },

    AndarBaharSn: {
      redirectUrl: "/casino/sn-andar-bahar",
      code: "",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/AndarBahar.webp",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      providerName: "Supernowa",
    },
    ClassicAndarBaharSn: {
      redirectUrl: "/casino/sn-classic-andar-bahar",
      code: "",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/ClassicAndarBahar.webp",
      alt: "Classic Andar Bahar",
      name: "Classic Andar Bahar",
      providerName: "Supernowa",
    },
    GoasAndarBaharSn: {
      redirectUrl: "/casino/sn-goas-andar-bahar",
      code: "",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/Goa'sAndarBahar.webp",
      alt: "Goa's Andar Bahar",
      name: "Goa's Andar Bahar",
      providerName: "Supernowa",
    },
    // RNGAndarBahar2020Sn: {
    //   redirectUrl: "/casino/sn-rng-andar-bahar-2020",
    //   code: "",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/andarbahar/supernowa/RNGAndarBahar2020.webp",
    //   alt: "RNG Andar Bahar 2020",
    //   name: "RNG Andar Bahar 2020",
    //   providerName: "Supernowa",
    // },
    name: "AndarBahar",
    key: "andarbahar",
  },

  gameshows: {
    BalloonRaceEvoGS: {
      redirectUrl: "/casino/ezgevo-gonzos-balloon-race",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/BaloonRace.webp",
      alt: "",
      name: "Balloon Race",
      providerName: "Evolution",
    },
    StockMarketEvoGS: {
      redirectUrl: "/casino/ezgevo-stock-market",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/StockMarket.webp",
      alt: "",
      name: "Stock Market",
      providerName: "Evolution",
    },
    CrazyTimeAEvoGS: {
      redirectUrl: "/casino/crazy-time-a",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/CrazyTimeA.webp",
      alt: "",
      name: "Crazy Time A",
      providerName: "Evolution",
    },
    CashOrCrashEvoGS: {
      redirectUrl: "/casino/ezgevo-cash-or-crash",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/CashOrCrash.webp",
      alt: "",
      name: "Cash or Crash",
      providerName: "Evolution",
    },
    DreamCatcherEvoGS: {
      redirectUrl: "/casino/ezgevo-dream-catcher",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/DreamCatcher.webp",
      alt: "",
      name: "Dream Catcher",
      providerName: "Evolution",
    },
    XXXtremeLightningRouletteEvoGS: {
      redirectUrl: "/casino/ezgevo-xxxtreme-lightning-roulette",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/XxxtremeLightningRoulette.webp",
      alt: "",
      name: "XXXtreme Lightning Roulette",
      providerName: "Evolution",
    },
    DeadOrAliveSaloonEvoGS: {
      redirectUrl: "/casino/ezgevo-dead-or-alive-saloon",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/DeadorAliveSaloon.webp",
      alt: "",
      name: "Dead or Alive: Saloon",
      providerName: "Evolution",
    },
    FootballStudioEvoGS: {
      redirectUrl: "/casino/ezgevo-football-studio",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/FootballStudio.webp",
      alt: "",
      name: "Football Studio",
      providerName: "Evolution",
    },
    GonzosTreasureMapEvoGS: {
      redirectUrl: "/casino/ezgevo-gonzos-treasure-map",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/GonzosTreasureMap.webp",
      alt: "",
      name: "Gonzo's Treasure Map",
      providerName: "Evolution",
    },
    LightningDiceEvoGS: {
      redirectUrl: "/casino/ezgevo-lightning-dice",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/LightningDice.webp",
      alt: "",
      name: "Lightning Dice",
      providerName: "Evolution",
    },
    CrazyTimeEvoGS: {
      redirectUrl: "/casino/ezgevo-crazy-time",
      code: "1000148",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/CrazyTime.jpg",
      alt: "",
      name: "Crazy Time",
      providerName: "Evolution",
    },
    LightningRouletteEvoGS: {
      redirectUrl: "/casino/ezgevo-lightning-roulette",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/LightningRoulette.webp",
      alt: "",
      name: "Lightning Roulette",
      providerName: "Evolution",
    },
    MegaBallEvoGS: {
      redirectUrl: "/casino/ezgevo-mega-ball",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/MegaBall.webp",
      alt: "",
      name: "Mega Ball",
      providerName: "Evolution",
    },
    name: "Game Shows",
    key: "gameshows",
  },

  roulette: {
    AutoRouletteEzg: {
      redirectUrl: "/casino/ezg-auto-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/AutoRoulette.webp",
      alt: "",
      name: "Auto Roulette",
      providerName: "Ezugi",
    },
    CasinoMarinaRoulette1Ezg: {
      redirectUrl: "/casino/ezg-casino-marina-roulette-1",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/CasinoMarinaRoulette1.webp",
      alt: "",
      name: "Casino Marina Roulette 1",
      providerName: "Ezugi",
    },
    CasinoMarinaRoulette2Ezg: {
      redirectUrl: "/casino/ezg-casino-marina-roulette-2",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/CasinoMarinaRoulette2.webp",
      alt: "",
      name: "Casino Marina Roulette 2",
      providerName: "Ezugi",
    },
    CricketAutoRouletteEzg: {
      redirectUrl: "/casino/ezg-cricket-auto-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/CricketAutoRoulette.webp",
      alt: "",
      name: "Cricket Auto Roulette",
      providerName: "Ezugi",
    },
    DiamondRouletteEzg: {
      redirectUrl: "/casino/ezg-diamond-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/DiamondRoulette.webp",
      alt: "",
      name: "Diamond Roulette",
      providerName: "Ezugi",
    },
    FirstPersonAmericanRouletteEzg: {
      redirectUrl: "/casino/ezg-first-person-american-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/FirstPersonAmericanRoulette.webp",
      alt: "",
      name: "First Person American Roulette",
      providerName: "Ezugi",
    },
    FootballAutoRouletteEzg: {
      redirectUrl: "/casino/ezg-football-auto-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/FootballAutoRoulette.webp",
      alt: "",
      name: "Football Auto Roulette",
      providerName: "Ezugi",
    },
    ItalianRouletteEzg: {
      redirectUrl: "/casino/ezg-italian-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/ItalianRoulette.webp",
      alt: "",
      name: "Italian Roulette",
      providerName: "Ezugi",
    },
    NamasteRouletteEzg: {
      redirectUrl: "/casino/ezg-namaste-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/NamasteRoulette.webp",
      alt: "",
      name: "Namaste Roulette",
      providerName: "Ezugi",
    },
    RoletaDaSorteEzg: {
      redirectUrl: "/casino/ezg-roleta-da-sorte",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/RoletaDaSorte.webp",
      alt: "",
      name: "Roleta Da Sorte",
      providerName: "Ezugi",
    },
    // RuletaAEzg: {
    //   redirectUrl: "/casino/ezg-ruleta-a",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/roulette/ezugi/RuletaA.webp",
    //   alt: "",
    //   name: "Ruleta A",
    //   providerName: "Ezugi",
    // },
    RuletaDelSolEzg: {
      redirectUrl: "/casino/ezg-ruleta-del-sol",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/RuletaDelSol.webp",
      alt: "",
      name: "Ruleta Del Sol",
      providerName: "Ezugi",
    },
    RussianRouletteEzg: {
      redirectUrl: "/casino/ezg-russian-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/RussianRoulette.webp",
      alt: "",
      name: "Russian Roulette",
      providerName: "Ezugi",
    },
    SkylineRouletteEzg: {
      redirectUrl: "/casino/ezg-skyline-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SkylineRoulette.webp",
      alt: "",
      name: "Skyline Roulette",
      providerName: "Ezugi",
    },
    SpanishRouletteEzg: {
      redirectUrl: "/casino/ezg-spanish-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SpanishRoulette.webp",
      alt: "",
      name: "Spanish Roulette",
      providerName: "Ezugi",
    },
    SpeedAutoRouletteEzg: {
      redirectUrl: "/casino/ezg-speed-auto-roulette",
      code: "221002",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SpeedAutoRoulette.webp",
      alt: "",
      name: "Speed Auto Roulette",
      providerName: "Ezugi",
    },
    SpeedRouletteEzg: {
      redirectUrl: "/casino/ezg-speed-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SpeedRoulette.webp",
      alt: "",
      name: "Speed Roulette",
      providerName: "Ezugi",
    },
    TurkishRouletteEzg: {
      redirectUrl: "/casino/ezg-turkish-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/TurkishRoulette.webp",
      alt: "",
      name: "Turkish Roulette",
      providerName: "Ezugi",
    },
    UltimateRouletteEzg: {
      redirectUrl: "/casino/ezg-ultimate-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/UltimateRoulette.webp",
      alt: "",
      name: "Ultimate Roulette",
      providerName: "Ezugi",
    },
    VIPRouletteEzg: {
      redirectUrl: "/casino/ezg-vip-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/VIPRoulette.webp",
      alt: "",
      name: "VIP Roulette",
      providerName: "Ezugi",
    },

    AmericanRouletteEvo: {
      redirectUrl: "/casino/ezgevo-american-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/AmericanRoulette.webp",
      alt: "",
      name: "American Roulette",
      providerName: "Evolution",
    },
    AutoRouletteEvo: {
      redirectUrl: "/casino/ezgevo-auto-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/AutoRoulette.webp",
      alt: "",
      name: "Auto Roulette",
      providerName: "Evolution",
    },
    DoubleBallRouletteEvo: {
      redirectUrl: "/casino/ezgevo-double-ball-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/DoubleBallRoulette.webp",
      alt: "",
      name: "Double Ball Roulette",
      providerName: "Evolution",
    },
    DragonaraRouletteEvo: {
      redirectUrl: "/casino/ezgevo-dragonara-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/DragonaraRoulette.webp",
      alt: "",
      name: "Dragonara Roulette",
      providerName: "Evolution",
    },
    FirstPersonAmericanRouletteEvo: {
      redirectUrl: "/casino/ezgevo-first-person-american-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/FirstPersonAmericanRoulette.webp",
      alt: "",
      name: "First Person American Roulette",
      providerName: "Evolution",
    },
    FootballStudioRouletteEvo: {
      redirectUrl: "/casino/ezgevo-football-studio-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/FootballStudioRoulette.webp",
      alt: "",
      name: "Football Studio Roulette",
      providerName: "Evolution",
    },
    InstantRouletteEvo: {
      redirectUrl: "/casino/ezgevo-instant-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/InstantRoulette.webp",
      alt: "",
      name: "Instant Roulette",
      providerName: "Evolution",
    },
    LightningRouletteEvo: {
      redirectUrl: "/casino/ezgevo-lightning-roulette",
      code: "1000148",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/LightningRoulette.webp",
      alt: "",
      name: "Lightning Roulette",
      providerName: "Evolution",
    },
    RoulettEvo: {
      redirectUrl: "/casino/ezgevo-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/Roulett.webp",
      alt: "",
      name: "Roulett",
      providerName: "Evolution",
    },
    SpeedAutoRouletteEvo: {
      redirectUrl: "/casino/ezgevo-speed-auto-roulette",
      code: "1000103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/SpeedAutoRoulette.webp",
      alt: "",
      name: "Speed Auto Roulette-EVO",
      providerName: "Evolution",
    },
    SpeedRouletteEvo: {
      redirectUrl: "/casino/ezgevo-speed-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/SpeedRoulette.webp",
      alt: "",
      name: "Speed Roulette",
      providerName: "Evolution",
    },
    TurkishLightningRouletteEvo: {
      redirectUrl: "/casino/ezgevo-turkish-lightning-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/TurkishLightningRoulette.webp",
      alt: "",
      name: "Turkish Lightning Roulette",
      providerName: "Evolution",
    },
    VIPRouletteEvo: {
      redirectUrl: "/casino/ezgevo-vip-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/VipRoulette.webp",
      alt: "",
      name: "VIP Roulette",
      providerName: "Evolution",
    },
    XxxtremeLightningRouletteEvo: {
      redirectUrl: "/casino/ezgevo-xxxtreme-lightning-roulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/XxxtremeLightningRoulette.webp",
      alt: "",
      name: "Xxxtreme Lightning Roulette",
      providerName: "Evolution",
    },

    RouletteAura: {
      redirectUrl: "/casino/aura-roulette",
      code: "",
      casino: "aura",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/aura/Roulette.webp",
      alt: "",
      name: "Roulette",
      providerName: "Aura",
    },

    EuropeanAutoRouletteVivo: {
      redirectUrl: "/casino/vivo-european-auto-roulette",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/EuropeanAutoRoulette.webp",
      alt: "",
      name: "European Auto Roulette",
      providerName: "Vivo",
    },
    FrenchRouletteVivo: {
      redirectUrl: "/casino/vivo-french-roulette",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/FrenchRoulette.webp",
      alt: "",
      name: "French Roulette",
      providerName: "Vivo",
    },
    GalaxyRouletteVivo: {
      redirectUrl: "/casino/vivo-galaxy-roulette",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/GalaxyRoulette.webp",
      alt: "",
      name: "Galaxy Roulette",
      providerName: "Vivo",
    },
    LasVegasRouletteVivo: {
      redirectUrl: "/casino/vivo-las-vegas-roulette",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/LasVegasRoulette.webp",
      alt: "las vegas roulette",
      name: "Las Vegas Roulette",
      providerName: "Vivo",
    },
    Oracle360RouletteVivo: {
      redirectUrl: "/casino/vivo-oracle-360-roulette",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/Oracle360Roulette.webp",
      alt: "",
      name: "Oracle 360 Roulette",
      providerName: "Vivo",
    },
    OracleBlazeRouletteVivo: {
      redirectUrl: "/casino/vivo-oracle-blaze-roulette",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/OracleBlazeRoulette.webp",
      alt: "oracle blaze roulette",
      name: "Oracle Blaze Roulette",
      providerName: "Vivo",
    },
    PortomasoRouletteVivo: {
      redirectUrl: "/casino/vivo-portomaso-roulette",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/PortomasoRoulette.webp",
      alt: "vivo portomaso roulette",
      name: "Vivo Portomaso Roulette",
      providerName: "Vivo",
    },
    VARouletteVivo: {
      redirectUrl: "/casino/vivo-va-roulette",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/VARoulette.webp",
      alt: "",
      name: "VA Roulette",
      providerName: "Vivo",
    },

    // RouletteSn: {
    //   redirectUrl: "/casino/sn-roulette",
    //   code: "",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/roulette/supernowa/Roulette.webp",
    //   alt: "",
    //   name: "Roulette",
    //   providerName: "Supernowa",
    // },
    name: "Roulette",
    key: "roulette",
  },

  baccarat: {
    Baccarat: {
      redirectUrl: "/casino/ezg-baccarat",
      code: "101",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/Baccarat.webp",
      alt: "",
      name: "Baccarat",
      providerName: "Ezugi",
    },
    BaccaratEEzg: {
      redirectUrl: "/casino/ezg-baccarat-e",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/BaccaratE.webp",
      alt: "Baccarat E",
      name: "Baccarat E",
      providerName: "Ezugi",
    },
    CasinoMarinaBaccarat1Ezg: {
      redirectUrl: "/casino/ezg-casino-marina-baccarat-1",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat1.webp",
      alt: "Casino Marina Baccarat 1",
      name: "Casino Marina Baccarat 1",
      providerName: "Ezugi",
    },
    CasinoMarinaBaccarat2Ezg: {
      redirectUrl: "/casino/ezg-casino-marina-baccarat-2",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat2.webp",
      alt: "Casino Marina Baccarat 2",
      name: "Casino Marina Baccarat 2",
      providerName: "Ezugi",
    },
    CasinoMarinaBaccarat3Ezg: {
      redirectUrl: "/casino/ezg-casino-marina-baccarat-3",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat3.webp",
      alt: "Casino Marina Baccarat 3",
      name: "Casino Marina Baccarat 3",
      providerName: "Ezugi",
    },
    CasinoMarinaBaccarat4Ezg: {
      redirectUrl: "/casino/ezg-casino-marina-baccarat-4",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat4.webp",
      alt: "Casino Marina Baccarat 4",
      name: "Casino Marina Baccarat 4",
      providerName: "Ezugi",
    },
    FortuneBaccarat: {
      redirectUrl: "/casino/ezg-fortune-baccarat",
      code: "101",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/FortuneBaccarat.webp",
      alt: "Fortune Baccarat",
      name: "Fortune Baccarat",
      providerName: "Ezugi",
    },
    KnockoutBaccaratEzg: {
      redirectUrl: "/casino/ezg-knockout-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/KnockoutBaccarat.webp",
      alt: "Knockout Baccarat",
      name: "Knockout Baccarat",
      providerName: "Ezugi",
    },
    NoCommissionBaccaratAEzg: {
      redirectUrl: "/casino/ezg-no-commission-baccarat-a",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratA.webp",
      alt: "No Commission Baccarat A",
      name: "No Commission Baccarat A",
      providerName: "Ezugi",
    },
    NoCommissionBaccaratBEzg: {
      redirectUrl: "/casino/ezg-no-commission-baccarat-b",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratB.webp",
      alt: "No Commission Baccarat B",
      name: "No Commission Baccarat B",
      providerName: "Ezugi",
    },
    NoCommissionBaccaratCEzg: {
      redirectUrl: "/casino/ezg-no-commission-baccarat-c",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratC.webp",
      alt: "No Commission Baccarat C",
      name: "No Commission Baccarat C",
      providerName: "Ezugi",
    },
    NoCommissionBaccaratDEzg: {
      redirectUrl: "/casino/ezg-no-commission-baccarat-d",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratD.webp",
      alt: "No Commission Baccarat D",
      name: "No Commission Baccarat D",
      providerName: "Ezugi",
    },
    NoCommissionBaccaratEEzg: {
      redirectUrl: "/casino/ezg-no-commission-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratE.webp",
      alt: "No Commission Baccarat E",
      name: "No Commission Baccarat E",
      providerName: "Ezugi",
    },
    NoCommissionOverUnderBaccaratEzg: {
      redirectUrl: "/casino/ezg-no-commission-over-under-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionOverUnderBaccarat.webp",
      alt: "No Commission Over Under Baccarat",
      name: "No Commission Over Under Baccarat",
      providerName: "Ezugi",
    },
    OverUnderBaccaratEzg: {
      redirectUrl: "/casino/ezg-over-under-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/OverUnderBaccarat.webp",
      alt: "Over Under Baccarat",
      name: "Over Under Baccarat",
      providerName: "Ezugi",
    },
    // SpeedCricketBaccarat: {
    //   redirectUrl: "/casino/ezg-speed-cricket-baccarat",
    //   code: "101",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/Speedcricketbaccarat.jpg",
    //   alt: "Speed Cricket Baccarat",
    //   name: "Speed Cricket Baccarat",
    //   providerName: "Ezugi",
    // },
    SpeedFortuneBaccaratEzg: {
      redirectUrl: "/casino/ezg-speed-fortune-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/SpeedFortuneBaccarat.webp",
      alt: "Speed Fortune Baccarat",
      name: "Speed Fortune Baccarat",
      providerName: "Ezugi",
    },
    Super6BaccaratEzg: {
      redirectUrl: "/casino/ezg-super-6-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/Super6Baccarat.webp",
      alt: "Super 6 Baccarat",
      name: "Super 6 Baccarat",
      providerName: "Ezugi",
    },
    VIPFortuneBaccaratEzg: {
      redirectUrl: "/casino/ezg-vip-fortune-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/VIPFortuneBaccarat.webp",
      alt: "VIP Fortune Baccarat",
      name: "VIP Fortune Baccarat",
      providerName: "Ezugi",
    },
    // VIPNoCommissionSpeedCricketBaccaratEzg: {
    //   redirectUrl: "/casino/ezg-vip-no-commission-speed-cricket-baccarat",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl:
    //     "./images/baccarat/ezugi/VIPNoCommissionSpeedCricketBaccarat.webp",
    //   alt: "VIP No Commission Speed Cricket Baccarat",
    //   name: "VIP No Commission Speed Cricket Baccarat",
    //   providerName: "Ezugi",
    // },

    BaccaratBEvo: {
      redirectUrl: "/casino/ezgevo-baccarat-b",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/BaccaratB.webp",
      alt: "Baccarat B",
      name: "Baccarat B",
      providerName: "Evolution",
    },
    // BaccaratCEvo: {
    //   redirectUrl: "/casino/ezgevo-baccarat-c",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/evolution/BaccaratC.webp",
    //   alt: "Baccarat C",
    //   name: "Baccarat C",
    //   providerName: "Evolution",
    // },
    BaccaratSqueezeEvo: {
      redirectUrl: "/casino/ezgevo-baccarat-squeeze",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/BaccaratSqueeze.webp",
      alt: "Baccarat Squeeze",
      name: "Baccarat Squeeze",
      providerName: "Evolution",
    },
    FirstPersonBaccaratEvo: {
      redirectUrl: "/casino/ezgevo-first-person-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/FirstPersonBaccarat.webp",
      alt: "First Person Baccarat",
      name: "First Person Baccarat",
      providerName: "Evolution",
    },
    FirstPersonGoldenWealthBaccaratEvo: {
      redirectUrl: "/casino/ezgevo-first-person-golden-wealth-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl:
        "./images/baccarat/evolution/FirstPersonGoldenWealthBaccarat.webp",
      alt: "First Person Golden Wealth Baccarat",
      name: "First Person Golden Wealth Baccarat",
      providerName: "Evolution",
    },
    FirstPersonLightningBaccaratEvo: {
      redirectUrl: "/casino/ezgevo-first-person-lightning-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/FirstPersonLightningBaccarat.webp",
      alt: "First Person Lightning Baccarat",
      name: "First Person Lightning Baccarat",
      providerName: "Evolution",
    },
    GoldenWealthBaccaratEvo: {
      redirectUrl: "/casino/ezgevo-golden-wealth-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/GoldenWealthBaccarat.webp",
      alt: "Golden Wealth Baccarat",
      name: "Golden Wealth Baccarat",
      providerName: "Evolution",
    },
    LightningBaccaratEvo: {
      redirectUrl: "/casino/ezgevo-lightning-baccarat",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/LightningBaccarat.webp",
      alt: "Lightning Baccarat",
      name: "Lightning Baccarat",
      providerName: "Evolution",
    },
    NoCommissionBaccaratEvo: {
      redirectUrl: "/casino/ezgevo-no-commission-baccarat-evo",
      code: "1000018",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/NoCommissionBaccarat.webp",
      alt: "No Commission Baccarat",
      name: "No Commission Baccarat",
      providerName: "Evolution",
    },
    SpeedBaccaratAEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-a",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratA.webp",
      alt: "Speed Baccarat A",
      name: "Speed Baccarat A",
      providerName: "Evolution",
    },
    SpeedBaccaratBEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-b",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratB.webp",
      alt: "Speed Baccarat B",
      name: "Speed Baccarat B",
      providerName: "Evolution",
    },
    SpeedBaccaratCEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-c",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratC.webp",
      alt: "Speed Baccarat C",
      name: "Speed Baccarat C",
      providerName: "Evolution",
    },
    SpeedBaccaratDEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-d",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratD.webp",
      alt: "Speed Baccarat D",
      name: "Speed Baccarat D",
      providerName: "Evolution",
    },
    SpeedBaccaratEEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-e",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratE.webp",
      alt: "Speed Baccarat E",
      name: "Speed Baccarat E",
      providerName: "Evolution",
    },
    SpeedBaccaratFEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-f",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratF.webp",
      alt: "Speed Baccarat F",
      name: "Speed Baccarat F",
      providerName: "Evolution",
    },
    SpeedBaccaratGEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-g",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratG.webp",
      alt: "Speed Baccarat G",
      name: "Speed Baccarat G",
      providerName: "Evolution",
    },
    SpeedBaccaratHEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-h",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratH.webp",
      alt: "Speed Baccarat H",
      name: "Speed Baccarat H",
      providerName: "Evolution",
    },
    SpeedBaccaratIEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-i",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratI.webp",
      alt: "Speed Baccarat I",
      name: "Speed Baccarat I",
      providerName: "Evolution",
    },
    SpeedBaccaratJEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-j",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratJ.webp",
      alt: "Speed Baccarat J",
      name: "Speed Baccarat J",
      providerName: "Evolution",
    },
    SpeedBaccaratREvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-r",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratR.webp",
      alt: "Speed Baccarat R",
      name: "Speed Baccarat R",
      providerName: "Evolution",
    },
    SpeedBaccaratVEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-v",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratV.webp",
      alt: "Speed Baccarat V",
      name: "Speed Baccarat V",
      providerName: "Evolution",
    },
    SpeedBaccaratWEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-w",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratW.webp",
      alt: "Speed Baccarat W",
      name: "Speed Baccarat W",
      providerName: "Evolution",
    },
    SpeedBaccaratXEvo: {
      redirectUrl: "/casino/ezgevo-speed-baccarat-x",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratX.webp",
      alt: "Speed Baccarat X",
      name: "Speed Baccarat X",
      providerName: "Evolution",
    },

    BaccaratAura: {
      redirectUrl: "/casino/aura-baccarat",
      code: "",
      casino: "aura",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/aura/Baccarat.webp",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "Aura",
    },
    Card29BaccaratAura: {
      redirectUrl: "/casino/aura-29-card-baccarat",
      code: "",
      casino: "aura",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/aura/29CardBaccarat.webp",
      alt: "29 Card Baccarat",
      name: "29 Card Baccarat",
      providerName: "Aura",
    },

    GalaxyBaccarat1Vivo: {
      redirectUrl: "/casino/vivo-galaxy-baccarat-1",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/GalaxyBaccarat1.webp",
      alt: "Galaxy Baccarat 1",
      name: "Galaxy Baccarat 1",
      providerName: "Vivo",
    },
    GalaxyBaccarat2Vivo: {
      redirectUrl: "/casino/vivo-galaxy-baccarat-2",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/GalaxyBaccarat2.webp",
      alt: "Galaxy Baccarat 2",
      name: "Galaxy Baccarat 2",
      providerName: "Vivo",
    },
    GalaxyBaccarat3Vivo: {
      redirectUrl: "/casino/vivo-galaxy-baccarat-3",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/GalaxyBaccarat3.webp",
      alt: "Galaxy Baccarat 3",
      name: "Galaxy Baccarat 3",
      providerName: "Vivo",
    },
    MacauBaccaratVivo: {
      redirectUrl: "/casino/vivo-macau-baccarat",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      alt: "Macau Baccarat",
      name: "Macau Baccarat",
      providerName: "Vivo",
    },
    VABacarat1Vivo: {
      redirectUrl: "/casino/vivo-va-bacarat-1",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      alt: "VA Bacarat 1",
      name: "VA Bacarat 1",
      providerName: "Vivo",
    },
    VABacarat2Vivo: {
      redirectUrl: "/casino/vivo-va-bacarat-2",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      alt: "VA Bacarat 2",
      name: "VA Bacarat 2",
      providerName: "Vivo",
    },
    VABacarat3Vivo: {
      redirectUrl: "/casino/vivo-va-bacarat-3",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      alt: "VA Bacarat 3",
      name: "VA Bacarat 3",
      providerName: "Vivo",
    },
    VABacarat4Vivo: {
      redirectUrl: "/casino/vivo-va-bacarat-4",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      alt: "VA Bacarat 4",
      name: "VA Bacarat 4",
      providerName: "Vivo",
    },
    VABacarat5Vivo: {
      redirectUrl: "/casino/vivo-va-bacarat-5",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      alt: "VA Bacarat 5",
      name: "VA Bacarat 5",
      providerName: "Vivo",
    },

    BaccaratSn: {
      redirectUrl: "/casino/sn-baccarat",
      code: "",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/supernowa/Baccarat.webp",
      alt: "Baccarat",
      name: "Baccarat",
      providerName: "Supernowa",
    },
    RNGBaccaratSn: {
      redirectUrl: "/casino/sn-rng-baccarat",
      code: "",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/supernowa/Baccarat.webp",
      alt: "RNG Baccarat",
      name: "RNG Baccarat",
      providerName: "Supernowa",
    },
    // RNGBaccarat2020Sn: {
    //   redirectUrl: "/casino/sn-rng-baccarat-2020",
    //   code: "",
    //   casino: "wco",
    //   provider: "SN",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/supernowa/RNGBaccarat2020.webp",
    //   alt: "RNG Baccarat 2020",
    //   name: "RNG Baccarat 2020",
    //   providerName: "Supernowa",
    // },
    name: "Baccarat",
    key: "baccarat",
  },

  dragontiger: {
    DragonTigerEzg: {
      redirectUrl: "/casino/ezg-dragon-tiger",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger//ezugi/DragonTiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
      providerName: "Ezugi",
    },
    DragonTigerDaSorteEzg: {
      redirectUrl: "/casino/ezg-dragon-tiger-da-sorte",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger//ezugi/DragonTigerDaSorte.webp",
      alt: "Dragon Tiger da Sorte",
      name: "Dragon Tiger da Sorte",
      providerName: "Ezugi",
    },

    DragonTigerEvo: {
      redirectUrl: "/casino/ezgevo-dragon-tiger-evo",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger/evolution/DragonTiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
      providerName: "Evolution",
    },
    FirstPersonDragonTigerEvo: {
      redirectUrl: "/casino/ezgevo-first-person-dragon-tiger",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger/evolution/First PersonDragonTiger.webp",
      alt: "First Person Dragon Tiger",
      name: "First Person Dragon Tiger",
      providerName: "Evolution",
    },
    LighteningDragontigerEvo: {
      redirectUrl: "/casino/ezgevo-lightening-dragon-tiger",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger/evolution/LightningDragonTiger.webp",
      alt: "Lightening Dragon tiger",
      name: "Lightening Dragon tiger",
      providerName: "Evolution",
    },

    DragonTigerAura: {
      redirectUrl: "/casino/aura-dragon-tiger",
      code: "",
      casino: "aura",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger/aura/DragonTiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
      providerName: "Aura",
    },
    DragonTigerVirtualAura: {
      redirectUrl: "/casino/aura-dragon-tiger-virtual",
      code: "",
      casino: "aura",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger/aura/DragonTigerVirtual.webp",
      alt: "Dragon Tiger (Virtual)",
      name: "Dragon Tiger (Virtual)",
      providerName: "Aura",
    },

    DragonTigerVivo: {
      redirectUrl: "/casino/vivo-dragon-tiger",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger/vivo/DragonTiger.webp",
      alt: "vivo Dragon Tiger",
      name: "Vivo Dragon Tiger",
      providerName: "Vivo",
    },
    VADragonTigerVivo: {
      redirectUrl: "/casino/vivo-dragon-tiger",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger/vivo/VADragonTiger.webp",
      alt: "VA Dragon Tiger",
      name: "VA Dragon Tiger",
      providerName: "Vivo",
    },

    DragonTigerSn: {
      redirectUrl: "/casino/sn-dragon-tiger",
      code: "",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger/supernowa/DragonTiger.webp",
      alt: "Dragon Tiger",
      name: "Dragon Tiger",
      providerName: "Supernowa",
    },
    RNGDragonTigerSn: {
      redirectUrl: "/casino/sn-rng-dragon-tiger",
      code: "",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger/supernowa/RNGDragonTiger.webp",
      alt: "RNG Dragon Tiger",
      name: "RNG Dragon Tiger",
      providerName: "Supernowa",
    },
    RNGDragonTiger2020Sn: {
      redirectUrl: "/casino/sn-rng-dragon-tiger-2020",
      code: "",
      casino: "wco",
      provider: "SN",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dragon-tiger/supernowa/RNGDragonTiger2020.webp",
      alt: "RNG Dragon Tiger 2020",
      name: "RNG Dragon Tiger 2020",
      providerName: "Supernowa",
    },
    name: "Dragon Tiger",
    key: "dragontiger",
  },

  blackjack: {
    // BlackjackAEzg: {
    //   redirectUrl: "/casino/ezg-blackjack-a",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/blackjack/ezugi/BlackjackA.webp",
    //   alt: "Blackjack A",
    //   name: "Blackjack A",
    //   providerName: "Ezugi",
    // },
    BlackjackDaSorteEzg: {
      redirectUrl: "/casino/ezg-blackjack-da-sorte",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/BlackjackDaSorte.webp",
      alt: "Blackjack Da Sorte",
      name: "Blackjack Da Sorte",
      providerName: "Ezugi",
    },
    GoldBlackjack1Ezg: {
      redirectUrl: "/casino/ezg-gold-blackjack-1",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/GoldBlackjack1.webp",
      alt: "Gold Blackjack 1",
      name: "Gold Blackjack 1",
      providerName: "Ezugi",
    },
    GoldBlackjack3Ezg: {
      redirectUrl: "/casino/ezg-gold-blackjack-3",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/GoldBlackjack3.webp",
      alt: "Gold Blackjack 3",
      name: "Gold Blackjack 3",
      providerName: "Ezugi",
    },
    Rumbablackjack1Ezg: {
      redirectUrl: "/casino/ezg-rumba-blackjack-1",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/RumbaBlackjack1.webp",
      alt: "Rumba Blackjack 1",
      name: "Rumba Blackjack 1",
      providerName: "Ezugi",
    },
    Rumbablackjack4Ezg: {
      redirectUrl: "/casino/ezg-rumba-blackjack-4",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/RumbaBlackjack4.webp",
      alt: "Rumba Blackjack 4",
      name: "Rumba Blackjack 4",
      providerName: "Ezugi",
    },
    SpanishUnlimitedBlackjackEzg: {
      redirectUrl: "/casino/ezg-spanish-unlimited-blackjack",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/SpanishUnlimitedBlackjack.webp",
      alt: "Spanish Unlimited Blackjack",
      name: "Spanish Unlimited Blackjack",
      providerName: "Ezugi",
    },
    UnlimitedBlackjackEzg: {
      redirectUrl: "/casino/ezg-unlimited-blackjack",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/UnlimitedBlackjack.webp",
      alt: "Unlimited Blackjack",
      name: "Unlimited Blackjack",
      providerName: "Ezugi",
    },
    VIPDiamondBlackjackEzg: {
      redirectUrl: "/casino/ezg-vip-diamond-blackjack",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/VIPDiamondBlackjack.webp",
      alt: "VIP Diamond Blackjack",
      name: "VIP Diamond Blackjack",
      providerName: "Ezugi",
    },
    VipSurrenderBlackjackEzg: {
      redirectUrl: "/casino/ezg-vip-surrender-blackjack",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/VipSurrenderBlackjack.webp",
      alt: "Vip Surrender Blackjack",
      name: "Vip Surrender Blackjack",
      providerName: "Ezugi",
    },

    BlackjackAEvo: {
      redirectUrl: "/casino/ezgevo-blackjack-a",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackA.webp",
      alt: "Blackjack A",
      name: "Blackjack A",
      providerName: "Evolution",
    },
    BlackjackPartyEvo: {
      redirectUrl: "/casino/ezgevo-blackjack-party",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackParty.webp",
      alt: "Blackjack Party",
      name: "Blackjack Party",
      providerName: "Evolution",
    },
    BlackjackSilverAEvo: {
      redirectUrl: "/casino/ezgevo-blackjack-silver-a",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackSilverA.webp",
      alt: "Blackjack Silver A",
      name: "Blackjack Silver A",
      providerName: "Evolution",
    },
    BlackjackVIP10Evo: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-10",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIP10.webp",
      alt: "Blackjack VIP 10",
      name: "Blackjack VIP 10",
      providerName: "Evolution",
    },
    BlackjackVIPAlphaEvo: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-alpha",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPAlpha.webp",
      alt: "Blackjack VIP Alpha",
      name: "Blackjack VIP Alpha",
      providerName: "Evolution",
    },
    BlackjackVIPBetaEvo: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-beta",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPBeta.webp",
      alt: "Blackjack VIP Beta",
      name: "Blackjack VIP Beta",
      providerName: "Evolution",
    },
    BlackjackVIPEEvo: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-e",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPE.webp",
      alt: "Blackjack VIP E",
      name: "Blackjack VIP E",
      providerName: "Evolution",
    },
    BlackjackVIPGammaEvo: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-gamma",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPGamma.webp",
      alt: "Blackjack VIP Gamma",
      name: "Blackjack VIP Gamma",
      providerName: "Evolution",
    },
    BlackjackVIPLEvo: {
      redirectUrl: "/casino/ezgevo-blackjack-vip-l",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPL.webp",
      alt: "Blackjack VIP L",
      name: "Blackjack VIP L",
      providerName: "Evolution",
    },
    ClassicSpeedBlackjack10Evo: {
      redirectUrl: "/casino/ezgevo-classic-speed-blackjack-10",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack10.webp",
      alt: "Classic Speed Blackjack 10",
      name: "Classic Speed Blackjack 10",
      providerName: "Evolution",
    },
    FirstPersonBlackjackEvo: {
      redirectUrl: "/casino/ezgevo-first-person-blackjack",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/FirstPersonBlackjack.webp",
      alt: "First Person Blackjack",
      name: "First Person Blackjack",
      providerName: "Evolution",
    },
    FirstPersonLightningBlackjackEvo: {
      redirectUrl: "/casino/ezgevo-first-person-lightning-blackjack",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/FirstPersonLightningBlackjack.webp",
      alt: "First Person Lightning Blackjack",
      name: "First Person Lightning Blackjack",
      providerName: "Evolution",
    },
    InfiniteBlackjackEvo: {
      redirectUrl: "/casino/ezgevo-infinite-blackjack",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/InfiniteBlackjack.webp",
      alt: "Infinite Blackjack",
      name: "Infinite Blackjack",
      providerName: "Evolution",
    },
    LightningBlackjackEvo: {
      redirectUrl: "/casino/ezgevo-lightning-blackjack",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/LightningBlackjack.webp",
      alt: "Lightning Blackjack",
      name: "Lightning Blackjack",
      providerName: "Evolution",
    },
    PowerBlackjackEvo: {
      redirectUrl: "/casino/ezgevo-power-blackjack",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/PowerBlackjack.webp",
      alt: "Power Blackjack",
      name: "Power Blackjack",
      providerName: "Evolution",
    },
    SpeedBlackjackDEvo: {
      redirectUrl: "/casino/ezgevo-speed-blackjack-d",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/SpeedBlackjackD.webp",
      alt: "Speed Blackjack D",
      name: "Speed Blackjack D",
      providerName: "Evolution",
    },
    SpeedVIPBlackjackAEvo: {
      redirectUrl: "/casino/ezgevo-speed-vip-blackjack-a",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/SpeedVIPBlackjackA.webp",
      alt: "Speed VIP Blackjack A",
      name: "Speed VIP Blackjack A",
      providerName: "Evolution",
    },

    LasVegasBlackjackVivo: {
      redirectUrl: "/casino/vivo-las-vegas-blackjack",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/vivo/LasVegasBlackjack.webp",
      alt: "Las Vegas Blackjack",
      name: "Las Vegas Blackjack",
      providerName: "Vivo",
    },
    LimitlessBlackjackVivo: {
      redirectUrl: "/casino/vivo-limitless-blackjack",
      code: "",
      casino: "vivo",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/vivo/LimitlessBlackjack.webp",
      alt: "Limitless Blackjack",
      name: "Limitless Blackjack",
      providerName: "Vivo",
    },
    name: "Blackjack",
    key: "blackjack",
  },

  sicbo: {
    SicBoEzg: {
      redirectUrl: "/casino/ezg-sic-bo",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/SicBo.webp",
      alt: "",
      name: "Sic Bo",
      providerName: "Ezugi",
    },
    ultimateSicBoEzg: {
      redirectUrl: "/casino/ezg-ultimate-sic-bo",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/UltimateSicBo.webp",
      alt: "",
      name: "Ultimate Sic Bo",
      providerName: "Ezugi",
    },

    SuperSicBoEvo: {
      redirectUrl: "/casino/ezgevo-super-sic-bo",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/SuperSicBo.webp",
      alt: "",
      name: "Super Sic Bo",
      providerName: "Evolution",
    },
    GonzosLightningSicBoEvo: {
      redirectUrl: "/casino/ezgevo-gonzos-lightning-sic-bo",
      code: "",
      casino: "Evolution",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/GonzosLightningSicBo.webp",
      alt: "",
      name: "Gonzos Lightning Sic Bo",
      providerName: "Evolution",
    },

    SicboKM: {
      redirectUrl: "/casino/km-sicbo",
      code: "",
      casino: "Kingmaker",
      provider: "Kingmaker",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/SicboKM.webp",
      alt: "",
      name: "Sicbo KM",
      providerName: "Kingmaker",
    },

    SicBoAes: {
      redirectUrl: "/casino/awc-sic-bo",
      code: "",
      casino: "AE Sexy",
      provider: "WorldCasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/SicBoAeSexy.webp",
      alt: "",
      name: "Sicbo AeSexy",
      providerName: "AeSexy",
    },
    ExtraSicBoAes: {
      redirectUrl: "/casino/awc-extra-sicbo",
      code: "",
      casino: "AE Sexy",
      provider: "WorldCasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/ExtraSicboAeSexy.webp",
      alt: "",
      name: "Extra Sicbo",
      providerName: "AeSexy",
    },

    GravitySicBoQt: {
      redirectUrl: "/casino/qtechbeterlive-gravity-sic-bo",
      code: "",
      casino: "BETER Live",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/BeterLiveGravitySicBo.webp",
      alt: "",
      name: "Gravity Sic Bo",
      providerName: "QTECH",
    },
    BLSicBoQt: {
      redirectUrl: "/casino/qtechbeterlive-sic-bo",
      code: "",
      casino: "BETER Live",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/BeterLiveSicBo.webp",
      alt: "",
      name: "Beter Live Sic Bo",
      providerName: "QTECH",
    },
    HabaneroSicBoQt: {
      redirectUrl: "/casino/qtechhabanero-sic-bo",
      code: "",
      casino: "Habanero",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/HabaneroSicBo.webp",
      alt: "",
      name: "Habanero Sic Bo",
      providerName: "QTECH",
    },
    TPGSicBoQt: {
      redirectUrl: "/casino/qtechtriplepg-sic-bo",
      code: "",
      casino: "Triple PG",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/TriplePGSicBo.webp",
      alt: "",
      name: "Triple PG Sic Bo",
      providerName: "QTECH",
    },
    PLSpeedSicBoQt: {
      redirectUrl: "/casino/qtechplaytechlive-speed-sic-bo-u1355",
      code: "",
      casino: "Playtech Live",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/PlaytechLiveSicBo.webp",
      alt: "",
      name: "Playtech Live Sic Bo",
      providerName: "QTECH",
    },
    name: "Sic Bo",
    key: "sicbo",
  },

  lucky7: {
    Lucky7Ezg: {
      redirectUrl: "/casino/ezg-lucky-7",
      code: "227103",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lucky7/Lucky7.jpg",
      alt: "",
      name: "Lucky 7",
      providerName: "Ezugi",
    },

    Lucky7SN: {
      redirectUrl: "/casino/sn-lucky-7",
      code: "",
      casino: "Supernowa",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lucky7/SN-Lucky7.webp",
      alt: "",
      name: "SN Lucky 7",
      providerName: "Supernowa",
    },
    RNGLucky7: {
      redirectUrl: "/casino/sn-rng-lucky-7",
      code: "",
      casino: "Supernowa",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lucky7/RNGLucky7.webp",
      alt: "",
      name: "RNG Lucky 7",
      providerName: "Supernowa",
    },

    Lucky7TVBG: {
      redirectUrl: "/casino/qtechbetgamestv-lucky-7",
      code: "",
      casino: "BetGames.TV",
      provider: "QT",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lucky7/TVBetLucky7.webp",
      alt: "",
      name: "TV BetGames Lucky 7",
      providerName: "Qtech",
    },
    Lucky7TPG: {
      redirectUrl: "/casino/qtechtriplepg-lucky-7-u8176",
      code: "",
      casino: "Triple PG",
      provider: "QT",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lucky7/TriplePGlucky7.webp",
      alt: "",
      name: "Triple PG Lucky 7",
      providerName: "Qtech",
    },
    Lucky7RTGSlots: {
      redirectUrl: "/casino/qtechrtgslots-lucky-7",
      code: "",
      casino: "RTG Slots",
      provider: "QT",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lucky7/RTGSlotsLucky7.webp",
      alt: "",
      name: "RTG Slots Lucky 7",
      providerName: "Qtech",
    },

    Lucky7Casino79: {
      redirectUrl: "/casino/casino79-lucky-7-a",
      code: "",
      casino: "Casino79",
      provider: "Casino79",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lucky7/Casino79Lucky7.webp",
      alt: "",
      name: "Casino79 Lucky 7",
      providerName: "Casino79",
    },

    up7down7KM: {
      redirectUrl: "/casino/km-7-up-7-down",
      code: "",
      casino: "",
      imgUrl: "./images/kingmaker/lucky7/7-up-7-down.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "7 up 7 down",
      providerName: "Kingmaker",
    },
    name: "Lucky 7",
    key: "lucky7",
  },

  crash: {
    JetX: {
      redirectUrl: "/casino/qtechsmartsoft-jetx-u5599",
      code: "",
      casino: "SmartSoft",
      provider: "QTECH",
      imgUrl: "./images/crash/JetX.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "JetX",
      providerName: "Crash",
    },
    JetX3: {
      redirectUrl: "/casino/qtechsmartsoft-jetx3-u2767",
      code: "",
      casino: "SmartSoft",
      provider: "QTECH",
      imgUrl: "./images/crash/JetX3.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "JetX3",
      providerName: "Crash",
    },
    Cappadocia: {
      redirectUrl: "/casino/qtechsmartsoft-cappadocia-u9350",
      code: "",
      casino: "SmartSoft",
      provider: "QTECH",
      imgUrl: "./images/crash/Cappadocia.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Cappadocia",
      providerName: "Crash",
    },
    CricketX: {
      redirectUrl: "/casino/qtechsmartsoft-cricketx-u6818",
      code: "",
      casino: "SmartSoft",
      provider: "QTECH",
      imgUrl: "./images/crash/CricketX.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "CricketX",
      providerName: "Crash",
    },
    SpinX: {
      redirectUrl: "/casino/qtechsmartsoft-spinx-u5864",
      code: "",
      casino: "SmartSoft",
      provider: "QTECH",
      imgUrl: "./images/crash/SpinX.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "SpinX",
      providerName: "Crash",
    },
    FootballX: {
      redirectUrl: "/casino/qtechsmartsoft-footballx-u9400",
      code: "",
      casino: "SmartSoft",
      provider: "QTECH",
      imgUrl: "./images/crash/FootballX.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "FootballX",
      providerName: "Crash",
    },
    name: "Crash",
    key: "crash",
  },

  slots: {
    PlinkoQT: {
      redirectUrl: "/casino/qt-plinko",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      imgUrl: "./images/slots/qtech/Plinko.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Plinko",
      providerName: "Slots",
    },
    DiceQT: {
      redirectUrl: "/casino/qt-dice",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      imgUrl: "./images/slots/qtech/Dice.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Dice",
      providerName: "Slots",
    },
    LimboQT: {
      redirectUrl: "/casino/qtechhacksawgaming-limbo",
      code: "",
      casino: "Qtech",
      provider: "Qtech",
      imgUrl: "./images/slots/qtech/Limbo.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Limbo",
      providerName: "Slots",
    },
    MinesQT: {
      redirectUrl: "/casino/qt-mines",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      imgUrl: "./images/slots/qtech/Mines.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Mines",
      providerName: "Slots",
    },
    HiloQT: {
      redirectUrl: "/casino/qt-hilo",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      imgUrl: "./images/slots/qtech/Hilo.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Hilo",
      providerName: "Slots",
    },
    LimboRiderQT: {
      redirectUrl: "/casino/qt-limbo-rider",
      code: "",
      casino: "Qtech",
      provider: "WorldCasino",
      imgUrl: "./images/slots/qtech/LimboRider.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Limbo Rider",
      providerName: "Slots",
    },
    name: "Slots",
    key: "slots",
  },

  cards32: {
    Cards32Ezg: {
      redirectUrl: "/casino/ezg-32-cards",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/card/32cards.jpg",
      alt: "",
      name: "32 Cards",
      providerName: "Ezugi",
    },
    name: "32 Cards",
    key: "cards32",
  },

  lottery: {
    EuroCup: {
      redirectUrl: "/casino/qtechmobilots-euro-cup",
      code: "",
      casino: "Mobilots",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/EuroCup.webp",
      alt: "",
      name: "Euro Cup",
      providerName: "QTECH",
    },
    CopaAmericaGame: {
      redirectUrl: "/casino/qtechmobilots-copa-america-game",
      code: "",
      casino: "Mobilots",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/CopaAmerica.webp",
      alt: "",
      name: "Copa América Game",
      providerName: "QTECH",
    },
    HotGear: {
      redirectUrl: "/casino/qtechgalaxsys-hot-gear",
      code: "",
      casino: "Galaxsys",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/HotGear.webp",
      alt: "",
      name: "Hot Gear",
      providerName: "QTECH",
    },
    LottoBoom: {
      redirectUrl: "/casino/qtechgalaxsys-lotto-boom",
      code: "",
      casino: "Galaxsys",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/LottoBoom.webp",
      alt: "",
      name: "Lotto Boom",
      providerName: "QTECH",
    },
    BingoStar: {
      redirectUrl: "/casino/qtechgalaxsys-bingo-star",
      code: "",
      casino: "Galaxsys",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/BingoStar.webp",
      alt: "",
      name: "Bingo Star",
      providerName: "QTECH",
    },
    Keno10Minute1: {
      redirectUrl: "/casino/qtechgalaxsys-keno-10-1-minute",
      code: "",
      casino: "Galaxsys",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/Keno10min1.webp",
      alt: "",
      name: "Keno 10 (1 Minute)",
      providerName: "QTECH",
    },
    Keno10Minute2: {
      redirectUrl: "/casino/qtechgalaxsys-keno-10-2-minute",
      code: "",
      casino: "Galaxsys",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/Keno10min2.webp",
      alt: "",
      name: "Keno 10 (2 Minute)",
      providerName: "QTECH",
    },
    KenoExpress: {
      redirectUrl: "/casino/qtechgalaxsys-keno-express",
      code: "",
      casino: "Galaxsys",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/KenoExpress.webp",
      alt: "",
      name: "Keno Express",
      providerName: "QTECH",
    },
    MultiDragonClassic: {
      redirectUrl: "/casino/qtechs4gaming-multi-dragon-classic",
      code: "",
      casino: "S4 Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/MultiDragonClassic.webp",
      alt: "",
      name: "Multi Dragon Classic",
      providerName: "QTECH",
    },
    SpinAndWin: {
      redirectUrl: "/casino/qtechkironinteractive-spin-and-win",
      code: "",
      casino: "Kiron Interactive",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/Spin&Win.webp",
      alt: "",
      name: "Spin And Win",
      providerName: "QTECH",
    },
    MagicKeno: {
      redirectUrl: "/casino/qtechturbogames-magic-keno",
      code: "",
      casino: "Turbo Games",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/MagicKeno.webp",
      alt: "",
      name: "Magic Keno",
      providerName: "QTECH",
    },
    CataratasBingo: {
      redirectUrl: "/casino/qtechwoohoogames-cataratas-bingo",
      code: "",
      casino: "Woohoo Games",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/CataratasBingo.webp",
      alt: "",
      name: "Cataratas Bingo",
      providerName: "QTECH",
    },
    GoGoBingo: {
      redirectUrl: "/casino/qtechwoohoogames-go-go-bingo",
      code: "",
      casino: "Woohoo Games",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/GoGoBingo.webp",
      alt: "",
      name: "Go-Go Bingo",
      providerName: "QTECH",
    },
    KenoDraw: {
      redirectUrl: "/casino/qtechwoohoogames-keno-draw",
      code: "",
      casino: "Woohoo Games",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/KenoDraw.webp",
      alt: "",
      name: "Keno Draw",
      providerName: "QTECH",
    },
    PescaBingo: {
      redirectUrl: "/casino/qtechwoohoogames-pesca-bingo",
      code: "",
      casino: "Woohoo Games",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/PescaBingo.webp",
      alt: "",
      name: "Pesca Bingo",
      providerName: "QTECH",
    },
    EgyptianRichesGold: {
      redirectUrl: "/casino/qtechvibragaming-egyptian-riches-gold-u2457",
      code: "",
      casino: "Vibra Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/lottery/EgyptianRichesGold.webp",
      alt: "",
      name: "Egyptian Riches Gold",
      providerName: "QTECH",
    },
    name: "Lottery",
    key: "lottery",
  },

  matka: {
    // WorliMatka: {
    //   redirectUrl: "/casino/sn-worli-matka",
    //   code: "",
    //   casino: "Supernowa",
    //   provider: "WorldCasino",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/matka/WorliMatka.webp",
    //   alt: "",
    //   name: "Worli Matka",
    //   providerName: "WorldCasino",
    // },
    RNGWorliMatka: {
      redirectUrl: "/casino/sn-rng-worli-matka",
      code: "",
      casino: "Supernowa",
      provider: "WorldCasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/matka/WorliMatka.webp",
      alt: "",
      name: "RNG Worli Matka",
      providerName: "WorldCasino",
    },
    MatkaAura: {
      redirectUrl: "/casino/aura-matka",
      code: "",
      casino: "Aura Gaming",
      provider: "AURA",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/matka/MatkaAura.webp",
      alt: "",
      name: "Matka Aura",
      providerName: "AURA",
    },
    MatkaVirtualAura: {
      redirectUrl: "/casino/aura-matka-virtual",
      code: "",
      casino: "Aura Gaming",
      provider: "AURA",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/matka/MatkaVirtual.webp",
      alt: "",
      name: "Matka Aura (Virtual)",
      providerName: "AURA",
    },
    name: "Matka",
    key: "matka",
  },

  multiplier: {
    DriveMultiplierMayhem: {
      redirectUrl: "/casino/ezgne-drive-multiplier-mayhem",
      code: "",
      casino: "Net Ent",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/multiplier/DriveMultiplierMayhem.webp",
      alt: "",
      name: "Drive Multiplier Mayhem",
      providerName: "Ezugi",
    },
    MultiplierRiches: {
      redirectUrl: "/casino/ezgrt-multiplier-riches",
      code: "",
      casino: "Red Tiger",
      provider: "Ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/multiplier/MultiplierRiches.webp",
      alt: "",
      name: "Multiplier Riches",
      providerName: "Ezugi",
    },
    MonsterMultipliers: {
      redirectUrl: "/casino/qtechplaytechcasino-monster-multipliers",
      code: "",
      casino: "Playtech Casino",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/multiplier/MonsterMultipliers.webp",
      alt: "",
      name: "Monster Multipliers",
      providerName: "QTECH",
    },
    MiamiMultiplier: {
      redirectUrl: "/casino/qtechhacksawgaming-miami-multiplier",
      code: "",
      casino: "Playtech Casino",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/multiplier/MiamiMultiplier.webp",
      alt: "",
      name: "Miami Multiplier",
      providerName: "QTECH",
    },
    DriveMultiplierMayhemNE: {
      redirectUrl: "/casino/qtechnetent-drive-multiplier-mayhem",
      code: "",
      casino: "NetEnt",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/multiplier/DriveMultiplierMayhemNE.webp",
      alt: "",
      name: "Drive: Multiplier Mayhem NE",
      providerName: "QTECH",
    },
    MultiplierRichesRT: {
      redirectUrl: "/casino/qtechredtiger-multiplier-riches",
      code: "",
      casino: "Red Tiger",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/multiplier/MultiplierRichesRT.webp",
      alt: "",
      name: "Multiplier Riches RT",
      providerName: "QTECH",
    },
    MultiplierOdysseyRG: {
      redirectUrl: "/casino/qtechrelaxgaming-multiplier-odyssey",
      code: "",
      casino: "Relax Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/multiplier/MultiplierOdyssey.webp",
      alt: "",
      name: "Multiplier Odyssey",
      providerName: "QTECH",
    },
    MultiplierMan: {
      redirectUrl: "/casino/qtechrevolvergaming-multiplier-man",
      code: "",
      casino: "Revolver Gaming",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/multiplier/MultiplierMan.webp",
      alt: "",
      name: "Multiplier Man",
      providerName: "QTECH",
    },
    WildBassMultiplier: {
      redirectUrl: "/casino/qtechmobilots-wild-bass-multiplier",
      code: "",
      casino: "Mobilots",
      provider: "QTECH",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/multiplier/WildBassMultiplier.webp",
      alt: "",
      name: "Wild Bass Multiplier",
      providerName: "QTECH",
    },
    name: "Multiplier",
    key: "multiplier",
  },
};
